import { useEffect, useState } from 'react';
import { api } from '../../api/client.js';
import { Loader, Alert, Empty, formatDate } from '../../components/ui.jsx';

const ACTION = {
  create: { icon: '➕', label: 'Created', cls: 'pill-good' },
  update: { icon: '✏️', label: 'Updated', cls: 'pill-warn' },
  delete: { icon: '🗑️', label: 'Deleted', cls: 'pill-bad' },
  bulk_create: { icon: '📋', label: 'Bulk created', cls: 'pill-good' },
  reset_password: { icon: '🔑', label: 'Reset password', cls: 'pill-warn' },
};

export default function SuperAudit() {
  const [entries, setEntries] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    api.auditLog().then(({ entries: list }) => setEntries(list)).catch((err) => setError(err.message));
  }, []);

  if (error) return <Alert kind="bad">{error}</Alert>;

  return (
    <>
      <div className="page-head">
        <div>
          <h1>📜 Audit log</h1>
          <p>Every account and school change made by a superadmin, newest first.</p>
        </div>
      </div>

      {!entries ? (
        <Loader label="Loading the log…" />
      ) : entries.length === 0 ? (
        <Empty icon="📜" title="Nothing logged yet" text="Changes appear here as soon as you make them." />
      ) : (
        <div className="table-wrap">
          <table className="data-table">
            <thead>
              <tr>
                <th>When</th>
                <th>Action</th>
                <th>Target</th>
                <th>Details</th>
                <th>By</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((e) => {
                const a = ACTION[e.action] ?? { icon: '•', label: e.action, cls: '' };
                return (
                  <tr key={e.id}>
                    <td className="small muted" style={{ whiteSpace: 'nowrap' }}>
                      {formatDate(e.created_at, true)}
                    </td>
                    <td>
                      <span className={`pill ${a.cls}`}>{a.icon} {a.label}</span>
                    </td>
                    <td>
                      <strong>{e.entity_type}</strong>
                      {e.entity_id ? <span className="faint small"> #{e.entity_id}</span> : null}
                    </td>
                    <td className="small muted">
                      {e.details ? (
                        <code className="code-chip">
                          {Object.entries(e.details)
                            .map(([k, v]) => `${k}: ${v === null ? '—' : v}`)
                            .join(' · ')}
                        </code>
                      ) : (
                        '—'
                      )}
                    </td>
                    <td className="small">
                      {e.actor ?? 'system'}
                      {e.actorUserId && <span className="faint"> ({e.actorUserId})</span>}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
}
